/**
 * @module Custom Cohesion HOC
 * @description
 */
import React, {FC, createContext, useState, useEffect} from 'react';
import type {AppProps} from 'next/app';
import {ProviderProps} from 'ui/types/providers';

interface Props {
    cohesionReady?: boolean;
    setCohesionReady?: (arg: boolean) => void;
    monarchProductReady?: boolean;
    setMonarchProductReady?: (arg: boolean) => void;
    monarchReady?: boolean;
    fuseNumber?: string | null;
}

const defaultState = {
    cohesionReady: false,
    setCohesionReady: () => {
    },
    monarchProductReady: false,
    setMonarchProductReady: () => {
    },
    monarchReady: false,
    fuseNumber: null
}
const DEFAULT_FUSE_NUMBER = '8664994271';

export const CustomCohesionContext = createContext<Props>(defaultState);

export const withCustomCohesion = ({App}: ProviderProps) => {
    const CustomCohesionProviderHOC: FC<AppProps> = (props) => {
        const [cohesionReady, setCohesionReady] = useState(false);
        const [monarchProductReady, setMonarchProductReady] = useState(false);
        const [monarchReady, setMonarchReady] = useState(false);
        const [fuseNumber, setFuseNumber] = useState<string | null>(null);

        useEffect(() => {
            window?.cohesion('ready', () => {
                setCohesionReady(true);
            })

            window?.cohesion('fuse:leasesReceived', (leases: { dnis: any; }[]) => {
                setFuseNumber(leases?.[0]?.dnis);
            });

            window?.cohesion('fuse:error',
                () => setFuseNumber(DEFAULT_FUSE_NUMBER)
            );

            cohesion("monarch:done", (err: any, evaluation: any) => {
                if (err) {
                    console.log("monarch:err", err);
                    return;
                }
                console.log("monarch:done", evaluation);
                setMonarchReady(true);
            });


        }, []);

        return (
            <CustomCohesionContext.Provider
                value={{
                    cohesionReady,
                    setCohesionReady,
                    monarchProductReady,
                    setMonarchProductReady,
                    fuseNumber,
                    monarchReady
                }}
            >
                <App {...props} />
            </CustomCohesionContext.Provider>
        );
    };

    return CustomCohesionProviderHOC;
};

export default withCustomCohesion;
